import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Button, Popup } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css'

import 'vendor/photoswipe/dist/photoswipe.css';
import 'vendor/photoswipe/dist/default-skin/default-skin.css';
import PhotoSwipe from 'vendor/photoswipe/dist/photoswipe.js';
import PhotoSwipeUI_Default from 'vendor/photoswipe/dist/photoswipe-ui-default.js';

import Fab from '@material-ui/core/Fab';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import GetAppIcon from '@material-ui/icons/GetApp';
import CloseIcon from '@material-ui/icons/Close';
import LaunchIcon from '@material-ui/icons/Launch';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import ShareIcon from '@material-ui/icons/Share';
import ZoomIcon from '@material-ui/icons/ZoomIn';

import { MOMENT_DOWNLOAD_URL } from 'shared/utils/Constants';
import { Mixpanel } from 'shared/services/Mixpanel';
import { hideNavBar, showNavBar } from 'shared/actions/navActions';
import Modal from 'shared/components/Modal';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  setPhotoSwipeOpen
} from 'shared/actions/photoSwipeActions';

import {
  createSharePage
} from 'shared/services/ShareService';

import { get } from 'shared/services/ApiService';

import { setMetaTag } from 'shared/services/MetaTags';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  form: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    background: '#fff',
    padding: '2rem 1rem',
    margin: '20vh auto 0',
    boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
    maxWidth: '600px',
    borderRadius: isMobile ? 0 : '3px'
  },
  formBackdrop: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#949494',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1
    }
  },
  button: {
    border: 'none',
    borderRadius: '3px',
    background: '#000',
    color: 'orage',
    fontWeight: 600,
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    width: '100%',
    marginTop: '1rem'
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '7rem',
    background: '#000'
  },
  footerContent: {
    position: 'relative',
    float: 'left',
    width: '100%',
    padding: '1.2rem 0.5rem 1.5rem',
  },
  logo: {
    position: 'relative',
    float: 'left',
    height: '3rem',
    width: 'auto',
    minWidth: '3rem',
    background: '#fff'
  },
  brand: {
    position: 'relative',
    float: 'left',
    color: '#fff',
    fontWeight: 600,
    marginLeft: '0.5rem'
  },
  launchIcon: {
    position: 'relative',
    float: 'right',
    color: '#fff',
    fontSize: '2rem',
    margin: '0.5rem'
  },
  footerSubtitle: {
    color: 'white',
    fontFamily: config.sub_font,
  },
  launchStore: {
    color: '#EBA900 !important'
  },
  actionIcon: {
    color: 'white !important'
  }
});

class PhotoSwipeWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.pswpElement = createRef();
    this.running = false;
    this.itemCount = 0;

    this.state = {
      shareIsOpen: false,
      currentMomentId: props.momentId
    };
  }

  shouldComponentUpdate(newProps, newState) {
    const storyId = this.getStoryId();

    return newProps.selectedMomentIds !== this.props.selectedMomentIds || newProps.open !== this.props.open ||
      (this.props.open && newProps.items[storyId].length !== this.props.items[storyId].length) ||
      newState.shareIsOpen !== this.state.shareIsOpen ||
      newState.currentMomentId !== this.state.currentMomentId;
  }

  componentDidUpdate() {
    const { items } = this.props;
    const storyId = this.getStoryId();

    if (this.props.open === storyId && items[storyId]) {
      // ensure items are in the correct order
      if (this.running) {
        const newItemCount = items[storyId].length;

        if (newItemCount > this.itemCount) {
          // new items have been added
          for (let i = this.itemCount; i < newItemCount; i++) {
            this.photoSwipe.items.push(items[storyId][i]);
          }

          this.itemCount = newItemCount;

        } else if (!newItemCount) {
          // the items have been cleared while photoswipe is open.
          // no current support or use case for this.

        }

      } else {
        const items = this.props.items[storyId];
        this.itemCount = items.length;

        if (this.itemCount === 0) {
          return;
        }

        this.running = true;

        let index = this.props.index || 0;

        if (!index && this.props.momentId) {
          for (let i = 0, l = items.length; i < l; i++) {
            if (items[i].id === this.props.momentId) {
              index = i;
              break;
            }
          }
        }

        const options = {
          index: index,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          history: false
        };

        this.photoSwipe = new PhotoSwipe(
          this.pswpElement.current,
          PhotoSwipeUI_Default,
          items,
          options
        );

        //this.props.hideNavBar();
        this.hideNav();
        this.photoSwipe.init();

        setTimeout(() => this.setMetaTags(), 500);

        this.photoSwipe.listen('destroy', () => {
          //this.props.showNavBar();
          this.props.onClose();
          this.props.setPhotoSwipeOpen(false);
        });

        this.photoSwipe.listen('close', () => {
          //this.props.showNavBar();
          this.props.onClose();
          this.showNav();
        });

        this.photoSwipe.listen('afterChange', () => {
          this.setMetaTags();
          this.setState({currentMomentId: this.photoSwipe.currItem.id});
        });

        // set current moment in state for cart buttons
        this.setState({currentMomentId: this.photoSwipe.currItem.id});
      }
    } else {
      // photoswipe has been closed
      this.running = false;
    }
  }

  getStoryId() {
    const {
      storyId,
      openCartStoryId,
      story,
      showPremiumGallery
    } = this.props;

    if (storyId) {
      return storyId;
    }

    if (story && story.id) {
      return story.id;
    } else {
      if (showPremiumGallery) {
        return openCartStoryId;
      }
    }
  }

  setMetaTags() {
    if (this.props.moments) {
      for (let moment of this.props.moments) {
        if (moment.id === this.photoSwipe.currItem.id) {
          setMetaTag('og:url', moment.share_url);
          setMetaTag('og:image:url', moment.share_preview);
          setMetaTag('og:image:type', moment.type);
          setMetaTag('og:image:width', moment.width);
          setMetaTag('og:image:height', moment.height);
          break;
        }
      }
    }
  }

  hideNav() {
    let nav = document.getElementById('navbar');
    if (nav) {
      nav.style.opacity = 0;
      nav.style.pointerEvents = 'none';
    }
  }

  showNav() {
    let nav = document.getElementById('navbar');
    if (nav) {
      nav.style.opacity = 1;
      nav.style.pointerEvents = 'auto';
    }
  }

  openShare() {
    this.setState({ shareIsOpen: true });
  }

  closeShare() {
    this.setState({ shareIsOpen: false });
    window.currentModal.close();
  }

  getFilename(item) {
    if (!item.filename.match(/\.[a-z]+$/)) {
      let ext = item.mimeType.match(/\/([a-z]+$)/)[1];
      return `${item.filename}.${ext}`;
    } else {
      return item.filename;
    }
  }

  createFile(item, blob) {
    if (!item.filename || !item.mimeType) {
      return Promise.reject('item needs filename and mimeType.');
    } else {
      // ensure filename has an extension for share API
      let filename = this.getFilename(item);
      let file = new File([blob], filename, { type: item.mimeType });

      return Promise.resolve(file);
    }
  }

  share(event) {
    event.stopPropagation();
    let item = this.photoSwipe.currItem;

    var moment;
    for (let m of this.props.moments) {
      if (m.id === this.photoSwipe.currItem.id) {
        moment = m;
        break;
      }
    }

    if (!moment) {
      return;
    }

    const { story, user } = this.props;

    get(MOMENT_DOWNLOAD_URL(moment.id))
      .then(resp => resp.blob())
      .then(blob => this.createFile(item, blob))
      .then(file => {
        let params = {
          files: [file]
        };

        if (navigator.canShare && navigator.canShare(params)) {
          return navigator.share(params)
        }

        console.log('Web Share API 2.0 not supported. Sharing URL instead of file.');

        if (user.theme.id) {
          this.openShare();
        } else {
          const storyId = this.getStoryId();
          createSharePage(storyId, [moment.id]).then(page => {
            let params = {
              url: page.url,
              title: page.story_name,
              text: page.provider_name
            }

            if (navigator.share) {
              navigator.share(params);
            } else {
              alert(page.url);
            }
          });
        }
      });
  }

  //openPrintStore(event) {
  //  let printStoreUrl = this.props.printStoreUrl;
  //  let item = this.photoSwipe.currItem;

  //  if (this.props.passMomentToPrintStore && item.printStoreAccessible) {
  //    printStoreUrl = printStoreUrl.replace(/\d+$/, item.id);
  //  }

  //  let link = document.createElement('a');
  //  link.href = printStoreUrl;
  //  link.target = '_blank';
  //  link.click();
  //}

  shareEmail() {
    let item = this.photoSwipe.currItem;
    this.props.shareEmailFn(item);
  }

  shareSms() {
    let item = this.photoSwipe.currItem;
    this.props.shareSmsFn(item);
  }

  openPrintStore(event) {
    window.currentMomentsScreen.openPrintStore();
    event.preventDefault();
  }

  download(event) {
    //if (isMobile) {
    //  this.openShare();
    //} else {
    let item = this.photoSwipe.currItem;
    let link = document.createElement('a');

    link.href = MOMENT_DOWNLOAD_URL(item.id);
    link.download = this.getFilename(item);
    link.click();
    //}
  }

  renderShareDialog(classes) {
    const { user, story } = this.props;

    return (
      <Modal disableScrollbar={true}
        disableDrag={true}
        forceOpen={true}
        isOpen={this.state.shareIsOpen}
        close={this.closeShare.bind(this)}>
        <div className={classes.formBackdrop}></div>
        <div className={classes.form}>
          <CloseIcon className={classes.closeIcon} onClick={this.closeShare.bind(this)} style={{ pointerEvents: 'auto' }} />
          <p>Copy and Paste the following link in your browser</p>
          <p>{ user.theme.branch_link_url }</p>
        </div>
      </Modal>
    );
  }

  isSelected() {
    const { selectedMomentIds } = this.props;
    const { currentMomentId } = this.state;

    return selectedMomentIds && selectedMomentIds.includes(currentMomentId);
  }

  getTopBarLogo() {
    const { user } = this.props;
    let locale = 'en-us';
    if (user) {
      locale = user.locale
    }

    if (locale && locale.includes('de')) {
      return config.pwa_pswipe_footer_logo_german;
    } else if (locale && locale.includes('fr')) {
      return config.pwa_pswipe_footer_logo_french;
    } else {
      return config.pwa_pswipe_footer_logo;
    }
  }

  renderFooter(classes) {
    const { story, disableWebsiteLink } = this.props;

    if (!story || !story.provider_account_id) {
      return null;
    }

    let logo = story.provider_logo && (
      <img className={classes.logo}
        src={this.getTopBarLogo() !== '' ? this.getTopBarLogo() : story.provider_logo} />
    );

    let brand = story.provider_name && (
      <p className={classes.brand}>
        {story.provider_name}
      </p>
    );

    let launchIcon = story.provider_website && !config.mlb && (
      <LaunchIcon className={classes.launchIcon} />
    );

    let content = (
      <div className={classes.footerContent}>
        {logo}
        {brand}
        {launchIcon}
      </div>
    )

    if (story.provider_website && !disableWebsiteLink) {
      return (
        <a target="_blank" href={story.provider_website}>
          <div className={classes.footer}>
            {content}
          </div>
        </a>
      );
    } else {
      return (
        <div className={classes.footer}>
          {content}

        </div>
      );
    }
  }

  renderMobileCartFooter(classes) {
    return (
      <div className={classes.footer}>
        <Button onClick={
          this.props.onClickAddToCart.bind(this, this.props.storyId.replace("-unpurchased", ""), this.state.currentMomentId)
        }>
          {
            this.isSelected() ?
              "Remove from Cart" :
              "Add to Cart"
          }
        </Button>
      </div>
    );
  }

  renderHPXFooter(classes) {
    const { story, disableWebsiteLink } = this.props;

    if (!story || !story.provider_account_id) {
      return null;
    }

    let content = (
      <div className={classes.footerContent}>
        <img src={this.getTopBarLogo()} height="30px" width="250px" />
        &nbsp;
        <a href={story.provider_website} target='_blank'>
          <LaunchIcon className={classes.launchStore} />
        </a>
        <br />
        <label className={classes.footerSubtitle}>
          <FormattedMessage {...messages.consumer_store_title} />
        </label>
      </div >
    )

    return (
      <div className={classes.footer}>
        {content}
      </div>
    );
  }

  render() {
    if (!this.props.open) {
      return null;
    }

    //const { classes, disableActions } = this.props;
    const { user, classes, showActions } = this.props;
    const { currentMomentId } = this.state;

    let disableActions = true;
    if (showActions) {
      disableActions = false;
    }

    const storyId = this.getStoryId();
    const accountSettings = this.props.accountSettings && this.props.accountSettings[storyId];
    const externalPrintStore = accountSettings && accountSettings.external_print_store;
    const disablePrintStore = accountSettings && accountSettings.disable_print_store;
    const disableShare = accountSettings && accountSettings.disable_share_photo;

    var printStoreIcon = "",
      downloadIcon = "",
      shareIcon = "",
      emailIcon = "",
      smsIcon = "",
      zoomIcon = "",
      closeIcon = "",
      footer = "";

    if (!disablePrintStore && !disableActions) {
      if (externalPrintStore) {
        let printStoreUrl = accountSettings && accountSettings.store_url;
        if (accountSettings && accountSettings.type == 8) {
          printStoreUrl += currentMomentId;
        }

        printStoreIcon = (
          <Popup
            content={<FormattedMessage {...messages.consumer_image_view_print_store} />}
            trigger={
              <a className="pswp__button" target="_blank" style={{ background: "none", paddingTop: '0.75rem' }} href={printStoreUrl}>
                <ShoppingCartIcon className={classes.actionIcon} style={{ height: "18px" }} />
              </a>
            }>
          </Popup>
        );

      } else {
        printStoreIcon = (
          <Popup
            content={<FormattedMessage {...messages.consumer_image_view_print_store} />}
            trigger={
              <button className="pswp__button" target="_blank" style={{ background: "none" }} onClick={this.openPrintStore.bind(this)}>
                <ShoppingCartIcon className={classes.actionIcon} style={{ height: "18px" }} />
              </button>
            }>
          </Popup>
        );
      }
    }

    // TODO: Disabling downloads for embedded apps across the board for now.  Worth making configurable later
    if (!disableActions && user.theme.id === 0) {
      downloadIcon = (
        <Popup
          content={<FormattedMessage {...messages.button_download} />}
          trigger={
            <button className="pswp__button" style={{ background: "none" }} onClick={this.download.bind(this)}>
              <GetAppIcon className={classes.actionIcon} style={{ height: "18px" }} />
            </button>
          }>
        </Popup>
      );
    }

    if (isMobile && !disableActions) {
      shareIcon = (
        <button className="pswp__button" title={
          <FormattedMessage {...messages.button_share} />
        } style={{ background: "none" }} onClick={this.share.bind(this)}>
          <ShareIcon className={classes.actionIcon} style={{ height: "18px" }} />
        </button>
      );
    }

    if (this.props.shareEmailFn) {
      emailIcon = (
        <button className="pswp__button" title="Share via Email" style={{ background: "none" }} onClick={this.shareEmail.bind(this)}>
          <MailOutlineIcon style={{ color: "#fff", height: "18px" }} />
        </button>
      );
    }

    if (this.props.shareSmsFn) {
      smsIcon = (
        <button className="pswp__button" title="Share via SMS" style={{ background: "none" }} onClick={this.shareSms.bind(this)}>
          <PhoneAndroidIcon style={{ color: "#fff", height: "18px" }} />
        </button>
      );
    }

    zoomIcon =
      (
        <Popup
          content={<FormattedMessage {...messages.button_image_view_zoom} />}
          trigger={
            <button className="pswp__button pswp__button--zoom"
              style={{ background: "none" }}>
              <ZoomIcon style={{ color: "#fff", height: "18px" }} />
            </button>
          }>
        </Popup>
      );

    closeIcon =
      (
        <Popup
          content={<FormattedMessage {...messages.button_close} />}
          trigger={
            <button className="pswp__button pswp__button--close" style={{ background: "none" }}>
              <CloseIcon style={{ color: "#fff", height: "18px" }} />
            </button>
          }>
        </Popup>
      );

    return (
      <div
        className="pswp"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={{ zIndex: 9999 }}
        ref={this.pswpElement}>
        <div className="pswp__bg" />
        <div className="pswp__scroll-wrap">
          <div className="pswp__container">
            <div className="pswp__item" style={{ userSelect: 'none' }} />
            <div className="pswp__item" style={{ userSelect: 'none' }} />
            <div className="pswp__item" style={{ userSelect: 'none' }} />
          </div>
          <div className="pswp__ui pswp__ui--hidden">
            <div className="pswp__top-bar">
              <div className="pswp__counter" />
              <Popup
                content={<FormattedMessage {...messages.button_close} />}
                trigger={
                  <button className="pswp__button pswp__button--close" />
                }>
              </Popup>
              {printStoreIcon}
              {shareIcon}
              {downloadIcon}
              {smsIcon}
              {emailIcon}
              <Popup
                content={<FormattedMessage {...messages.button_image_view_zoom} />}
                trigger={
                  <button className="pswp__button pswp__button--zoom" />
                }>
              </Popup>
              <div className="pswp__preloader">
                <div className="pswp__preloader__icn">
                  <div className="pswp__preloader__cut">
                    <div className="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div className="pswp__share-tooltip" />
            </div>
            <button className="pswp__button pswp__button--arrow--left" title={
              <FormattedMessage {...messages.button_image_view_previous} />
            } />
            <button className="pswp__button pswp__button--arrow--right" title={
              <FormattedMessage {...messages.button_image_view_next} />
            } />
            <div className="pswp__caption">
              <div className="pswp__caption__center" />
            </div>
          </div>
        </div>
        {this.renderShareDialog(classes)}
        {
          config.customer === 'hpx' &&
          this.renderHPXFooter(classes)
        }
        {
          this.props.isMobileCart &&
          this.renderMobileCartFooter(classes)
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nav: state.navReducer.nav,
  open: state.photoSwipeReducer.open,
  index: state.photoSwipeReducer.index,
  user: state.userReducer.user,
  momentId: state.photoSwipeReducer.momentId,
  items: state.photoSwipeReducer.items,
  accountSettings: state.storyReducer && state.storyReducer.accountSettings,
  openCartStoryId: state.storyReducer && state.storyReducer.openCartStoryId,
  selectedMomentIds: state.cartReducer && state.cartReducer.selectedMomentIds,
  showPremiumGallery: state.cartReducer && state.cartReducer.showPremiumGallery,
});

export default connect(mapStateToProps, { hideNavBar, showNavBar, setPhotoSwipeOpen })(withStyles(styles, { withTheme: true })(PhotoSwipeWrapper));
